
<template>
  <div class="">
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model.trim="input_agent" placeholder="请输入代理商" />
            </el-form-item>

          </el-form>

          <label style="padding-left: 3px;">
            <el-button @click="list(1)" size="small" type="primary" plain icon="el-icon-search">搜索</el-button>
            <!--<el-button style="margin-right:8px" size="small" type="primary" plain icon="el-icon-plus" @click="diaSalesman=true">新增业务员</el-button>-->
            <!--<el-button size="small" type="primary" plain  style="margin-right: 8px"  icon="el-icon-plus" @click="dialogFormVisible=true">新增代理商</el-button>-->
            <el-button v-if="roleId==='777'" @click="download" size="small" type="primary" plain icon="el-icon-download">导出代理商</el-button>
            <!--<el-button @click="importAll()" size="small" type="primary" plain icon="el-icon-download">代理折扣导出</el-button>-->

            <el-button style="margin-right: 8px" type="primary" plain icon="el-icon-plus" size="small" @click="clickPrestore">预存金额
            </el-button>

          </label>
        </div>

        <el-table :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                  :cell-style="{height:'5px,0',textAlign:'center'}"  border
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                  style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column show-overflow-tooltip prop="id" label="编号" width="180"></el-table-column>
          <el-table-column show-overflow-tooltip prop="agentId" label="代理商ID" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="agentName" label="代理商名字" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cardCount" label="总卡数" width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="agentLevel" label="代理商级别" width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="parentId" label="上级代理商" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createUser" label="创建人" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="status" label="合作状态" width="120">
            <template slot-scope="scope" >
              <span v-if="scope.row.status===0">已停止</span>
              <span v-if="scope.row.status===1">合作中</span>
            </template>
          </el-table-column>
          <el-table-column prop="prestorePrice" label="预存金额" min-width="100%"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button type="primary" size="small">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="fitProfit(scope.row.agentId)">设置分润</el-dropdown-item>
                  <el-dropdown-item @click.native="sysProfitDetails(scope.row.agentId)">分润详情</el-dropdown-item>
                  <el-dropdown-item v-if="roleId==='777'" @click.native="stopAgent(scope)">{{scope.row.status===0?'开启合作':'停止合作'}}</el-dropdown-item>
                  <el-dropdown-item v-if="roleId==='777'" @click.native="preStore(scope.row)">预存金额</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog v-if="diaPreStore" title="代理商账户预存金额充值" :close-on-click-modal="false"
                   :visible.sync="diaPreStore" class="class_dialog_hospital" width="41%">
          <div class="row">
            <div class="disflex" style="padding-bottom: 2%;">
              <div class="titleflex">代理名字:</div>
              <el-input v-model.trim="agentInfo.agentName" disabled />
            </div>
            <div class="disflex" style="padding-bottom: 2%;">
              <div class="titleflex">代理商Id:</div>
              <el-input v-model.trim="agentInfo.agentId" disabled />
            </div>
          </div>
          <div class="row">
            <div class="disflex" style="padding-bottom: 2%;">
              <div>预存金额：</div>
              <div>
                <el-input type="number" v-model.trim="prestore_price" style="width:100%;" placeholder="请输入预存金额" />
              </div>
            </div>
            <div class="disflex" style="padding-bottom: 2%;">
              <div>备注信息：</div>
              <div>
                <el-input v-model.trim="info" style="width:100%;" placeholder="请输入备注信息" />
              </div>
            </div>
          </div>
          <p style="color: red;">温馨提示：请确保已收到预存款再操作账户充值！</p>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaPreStore= false">取 消</el-button>
            <el-button size="small" type="primary" @click="preStored()">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog width="60%" v-if="diaFitProfit" :close-on-click-modal="false" data-height="700" title="设置分润" :visible.sync="diaFitProfit" class="class_dialog_hospital">
          <el-form style="margin-top: 2%;display: flex;justify-content: flex-start;" label-width="72px">
            <el-form-item  label="资源选择:">
              <el-select @focus="loadType" v-model="cardType" style="width: 93%;" clearable filterable allow-create placeholder="请选择通道">
                <el-option v-for="(item,index) in options" :label="item.cardTypeName" :value="item.cardTypeCode" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="套餐选择:">
              <el-select @focus="loadPackage" @change="selectPackage" v-model="packageId" style="width: 100%;" clearable filterable allow-create placeholder="请选择套餐">
                <el-option v-for="(item,index) in packages" :label="item.packageName" :value="item.packageId" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item style="margin-left: -3%">
              <el-button @click="selectPackage" size="small" type="primary" plain icon="el-icon-search">搜索</el-button>
            </el-form-item>-->
          </el-form>


          <!--<el-button size="small" type="primary" plain @click="syncCardPacket()" style="margin-bottom: 1%;">同步套餐</el-button>-->
          <el-button v-if="roleId==='777'" size="small" type="primary" plain @click="importNow()">导出套餐</el-button>
          <!--<el-button id="surebtn" size="small" type="primary" plain @click="openMust">按需分配</el-button>-->
          <el-table  :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}"
                    :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border
                    :data="packetTableData"  style="margin-top:1%;margin-bottom: 2%">
            <el-table-column  show-overflow-tooltip type="selection" width="55" :key="1" reserve-selection></el-table-column>
            <el-table-column min-width="100" prop="id" label="ID" show-overflow-tooltip></el-table-column>
            <el-table-column min-width="100" prop="packageId" label="套餐ID" show-overflow-tooltip></el-table-column>
            <el-table-column min-width="100" prop="packetName" label="加油包名" show-overflow-tooltip></el-table-column>
            <el-table-column min-width="100" prop="osPacketPrice" label="系统售价"></el-table-column>
            <el-table-column min-width="100" prop="osPacketCost" label="系统成本"></el-table-column>
            <el-table-column min-width="100" prop="packetFlow" label="流量"></el-table-column>
            <el-table-column min-width="100" prop="packetCost" :width="120" label="代理成本">
              <template slot-scope="scope">
                <span>
                  <el-input type="number" v-model.trim="scope.row.packetCost" size="mini" placeholder="成本价"></el-input>
                </span>
              </template>
            </el-table-column>
            <el-table-column v-if="roleId==='777'"  min-width="100" prop="errorTime" label="so个数">
              <template slot-scope="scope">
                <span>
                  <el-input type="number" v-model.trim="scope.row.errorTime" size="mini" placeholder="so个数"></el-input>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="设置">
              <template slot-scope="scope">
                <el-button type="primary" size="small" plain style="cursor: pointer;" @click="change(scope.row)">{{scope.row.packetCost?'保存':"修改"}}</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!--<div v-if="sureflag" slot="footer" class="dialog-footer">
            <el-button size="small" @click="suremust" type="primary">确认分配</el-button>
          </div>-->
        </el-dialog>

        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>
      </el-main>
    </el-container>


    <el-dialog :close-on-click-modal="false" title="账户预存金额" :visible.sync="prestoreDisable" class="class_dialog_hospital" width="40%">
      <el-form ref="prestoreForm" :model="prestoreForm" :rules="rules" label-width="110px">
        <el-form-item label="代理商ID">
          <el-input disabled v-model="prestoreForm.agentId" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input disabled v-model="prestoreForm.ordNo" />
        </el-form-item>
        <el-form-item label="交易类型">
          <el-input disabled v-model="prestoreForm.ordName" />
        </el-form-item>
        <el-form-item label="预存金额" prop="price">
          <el-input type="number" v-model="prestoreForm.price" />
        </el-form-item>
      </el-form>
      <div style="display: flex;flex-direction: column;align-items: center;margin-bottom: 20px;">
        <div style="font-weight: 700;">二维码位置</div>
        <div id="qrcode" style="margin: 0 auto"></div>
        <img v-if="showLogo" style="position:absolute;left:50%;top:70%;transform: translate(-50%,-50%);width: 30px"
              src="../../../static/img/index/prelogo.png">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePrestore">取 消</el-button>
        <el-button type="primary" @click="addPrestore('prestoreForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../../components/pagination'
import tools from '../../../utils/tools'
import check from '../../../static/js/check'

export default {
  name: 'agent',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    _this.roleId =_this.$loginUser.roleId
  },

  data() {
    let checkPhone = (rule, value, callback) => {
      if (!this.$check.checkPhone(value)) {
        return new callback(new Error('手机号码有误'))
      } else {
        callback()
      }
    }
    return {
      showLogo:false,
      roleId: '',
      maxHeight: 500,
      parentPrice: 0.0,
      prestore_price: 0.0,
      creditLimit: 0.0,
      info: '',
      rules: {
        agentId: [{ required: true, message: '请输入代理商ID', trigger: 'blur' }],
        agentName: [{ required: true, message: '请输入代理商名称', trigger: 'blur' }],
        agentMobile: [
          { required: true, message: '请输入代理商电话', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        agentLevel: [{ required: true, message: '请选择代理商级别', trigger: 'blur' }],
        parentId: [{ required: true, message: '一级默认输入0', trigger: 'blur' }],
        account: [{ required: true, message: '请输入代理商账户', trigger: 'blur' }],
        password: [{ required: true, message: '请输入代理商账户密码', trigger: 'blur' }]
      },
      agents: [],
      salesmans: [],
      agent: '',
      agentForm: {
        agentId: '',
        agentName: '',
        agentMobile: '',
        agentLevel: '',
        parentId: '',
        agentMchid: '',
        agentPresecret: '',
        prestorePrice: 0.00,
        createUser: ''
      },
      salesmanForm: {
        salesmanId: '',
        salesmanName: ''
      },
      agentInfo: {
        agentId: '',
        agentName: '',
        agentMobile: '',
        agentLevel: '',
        parentId: '',
        agentMchid: '',
        agentPresecret: '',
        prostorePrice: '0.00',
        creditLimit: '0.00'
      },
      openProfit: false,
      agentSelc: false,
      packetTableData: [],
      input_price: '',
      input_times: '',
      packageId: '',
      cardType: '',
      packages: [],
      options: [],
      diaFitProfit: false,
      diaPreStore: false,
      diaCredit: false,
      openAccount: false,
      input_agent: '',
      dialogFormVisible: false,
      //diaSalesman: false,
      tableData: [],
      agent_level: '',
      allPacketData: [],
      checkList: [],
      //sureflag: false,
      price: '差价',
      offline: '线下',
      lastmonth: '上月',
      agentJs: require('../../../api/agent'),
      cardTypeJs: require('../../../api/cardType'),
      packageJs: require('../../../api/package'),
      packetJs: require('../../../api/packet'),
      profitJs: require('../../../api/profit'),
      prestoreDisable: false,
      prestoreForm: {
        agentId: '',
        ordNo: '',
        ordName: '账户预存充值',
        price: '0.00'
      },
      sum: 0,
      timer: null,
    }
  },

  methods: {
    createOrdno() {
      let _this = this
      let aI = parseInt(Math.random() * 100000000) //数值型
      _this.prestoreForm.ordNo = 'zy-ord-preStord' + aI
    },
    queryOrder(ordNo) {
      let _this = this
      _this.agentJs.checkWxProstorePrice(ordNo)
          .then(res => {
            if (_this.sum === 30) {
              clearInterval(_this.timer)
              _this.showLogo=false
              document.getElementById('qrcode').innerHTML = "<div style='color: red;text-align: center'>时效已过，请点击确定刷新二维码</div>"
            }
            _this.sum++
            if (res.data.code === '0') {
              document.getElementById('qrcode').innerHTML = "<div style='color: red;text-align: center'>" + res.data.data + '</div>'
              setTimeout(_this.closePrestore, 5000)
              clearInterval(_this.timer)
            }
          })
          .catch(err => {
            document.getElementById('qrcode').innerHTML = '扫码失败'
            _this.showLogo=false
            clearInterval(_this.timer)
          })
    },
    addPrestore(prestoreForm) {
      let _this = this
      _this.createOrdno()
      clearInterval(_this.timer)
      document.getElementById('qrcode').innerHTML = ''
      _this.$refs[prestoreForm].validate(valid => {
        if (valid) {
          if(_this.prestoreForm.price<=1){
            _this.$alert("预存金额参数错误")
            return false
          }
          _this.agentJs.addAgentPrestorePrice(_this.prestoreForm)
              .then(res => {
                this.$nextTick(function () {
                  _this.showLogo=true
                  _this.$qrcode.createQRCode(document.getElementById('qrcode'),
                          res.data.data)
                })
                _this.timer = setInterval(function () {
                  _this.queryOrder(_this.prestoreForm.ordNo)
                }, 10000)
              })
              .catch(err => {
                _this.$alert(res.data.msg)
              })
        }
      })
    },
    closePrestore() {
      let _this = this
      clearInterval(_this.timer)
      document.getElementById('qrcode').innerHTML = ''
      _this.prestoreForm.price = 0.0
      _this.prestoreDisable = false
    },
    clickPrestore() {
      let _this = this
      _this.prestoreForm.agentId = _this.$loginUser.agentId
      _this.prestoreDisable = true
    },
    loadPackage() {
      let _this = this
      _this.packages=[]
      if(_this.$check.checkIsNull(_this.cardType)){
        _this.$notify.error("先选择资源")
        return false
      }
      _this.current_package = ''
      let data={
        current: 1,
        size: 10000,
        cardType: _this.cardType,
        agentId: _this.agentInfo.agentId
      }
      _this.packageJs.loadPackage(data)
              .then(res => {
                if (res.data.code === '0') {
                  _this.packages = res.data.data.rows
                }
              })
    },
    loadType() {
      let _this = this
      _this.options=[]
      _this.cardTypeJs.getNeedCardTypeList(_this.agentInfo.agentId).then(response => {
        _this.options = response.data.data
      })
    },

    selectPackage() {
      let _this = this
      _this.packetTableData =_this.$options.data().packetTableData
      if (_this.packageId !== '') {
        let data={
          packageId: _this.packageId,
          agentId: _this.agentInfo.agentId
        }
        _this.packetJs.getAgentPacket(data)
          .then(res => {
            if (res.data.code === '0') {
              _this.packetTableData = res.data.data
            }else{
              _this.$alert(res.data.msg)
            }
          })
      }
    },

    //修改
    change(result) {
      let _this = this
      //点击修改 判断是否已经保存所有操作
      let agentPacketCost = result.packetCost
      if (parseFloat(result.osPacketCost) - parseFloat(agentPacketCost) >0) {
        _this.$alert('代理成本价不能低于当前系统成本')
        return false
      }
      if (parseFloat(result.errorTime)>10 || parseFloat(result.errorTime)<1) {
        _this.$alert('SO个数取值在1-10')
        return false
      }
      /*if (_this.agent_level !== 1) {
        _this.$alert("无权设置非一级代理商的分润");
        return false;
      }*/
      _this.profitJs.setAgentProfit(result).then(res => {
        if (res.data.code === '0') {
          _this.$alert(res.data.data)
        } else {
          _this.$alert(res.data.msg)
        }
      })
    },
    fitProfit(val) {
      let _this = this
      _this.agentInfo.agentId=val
      _this.diaFitProfit = true
    },
    //分润详情
    sysProfitDetails(agentId) {
      let _this = this
      _this.$router.push({
        path: '/system/sysProfitDetails',
        query: { agentId: agentId }
      })
    },
    stopAgent(scope) {
      let _this = this
      let status = scope.row.status
      let text
      if(status===0){
        text='开启合作将进行分润支配，请确定是否此操作'
        _this.tableData[scope.$index].status=1
      }else{
        text='停止合作将关闭分润支配，请确定是否此操作'
        _this.tableData[scope.$index].status=0
      }
      _this
          .$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            let data={
              agentId: scope.row.agentId,
              status: status
            }
        _this.agentJs.stopAgent(data)
                .then(response => {
                  if (response.data.code === '0') {
                    _this.$alert(response.data.data)
                  } else {
                    _this.$alert(response.data.msg)
                  }

                })
                .catch(err => {
                  _this.$alert(err + '网络异常！')
                  _this.list(1)
                })
      })
    },
    preStore(row) {
      let _this = this
      _this.agentInfo.agentName = row.agentName
      _this.agentInfo.agentId = row.agentId
      _this.diaPreStore = true
    },
    preStored() {
      let _this = this
      if (_this.prestore_price<=0.00) {
        _this.$alert('输入的金额格式有误！')
        return false
      }
      let data={
        agentId: _this.agentInfo.agentId,
        prestore_price: _this.prestore_price,
        info: _this.info
      }
      _this.agentJs.addProstorePrice(data)
        .then(res => {
          if (res.data.code === '0') {
            _this.$alert(res.data.data)
            _this.diaPreStore = false
            _this.list(1)
          } else {
            _this.$alert(res.data.msg)
            _this.diaPreStore = false
            _this.list(1)
          }
        })
    },
    addAgent(agentForm) {
      let _this = this
      _this.$refs[agentForm].validate(valid => {
        if (valid) {
          _this.agentJs.addAgent( _this.agentForm).then(res => {
            if (res.data.code === '0') {
              _this.$alert(res.data.data)
              _this.agentForm = {}
              _this.dialogFormVisible = false
            } else {
              _this.$alert(res.data.msg)
              _this.agentForm = {}
              _this.dialogFormVisible = false
            }
          })
        } else {
          _this.$alert('保存失败')
          return false
        }
      })
    },
    /*addSalesman(salesmanForm) {
      let _this = this
      _this.$refs[salesmanForm].validate(valid => {
        if (valid) {
          _this.$ajax.post(process.env.VUE_APP_SERVER + '/system/agent/saveSalesman', _this.salesmanForm).then(res => {
            if (res.data.code === '0') {
              _this.$notify.success(res.data.data)
              _this.salesmanForm = {}
              _this.diaSalesman = false
            } else {
              _this.$notify.error(res.data.msg)
              _this.salesmanForm = {}
              _this.diaSalesman = false
            }
          })
        } else {
          _this.$notify.error('保存失败')
          return false
        }
      })
    },*/
    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.tableData = []
      let data={
        agentName: _this.input_agent,
        current: page,
        size: _this.$refs.pagination.size
      }
      _this.agentJs.getAgentList(data)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },

    importNow() {
      let _this = this
      if (JSON.stringify(_this.packetTableData) !== '[]') {
        require.ensure([], () => {
          const { export_json_to_excel } = require('../../../excel/Export2Excel')
          const tHeader = ['Id', '套餐Id', '加油包名称', '系统售价', '系统成本价', '流量', '当前代理成本', '当前代理Id', 'SO个数']
          const filterVal = ['id', 'packageId', 'packetName', 'osPacketPrice', 'osPacketCost', 'packetFlow', 'packetCost', 'agentId', 'errorTime']
          const list = this.packetTableData
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '套餐excel')
        })
      } else {
        _this.$confirm('没有可导出的数据,请查询出后再选择导出', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
      }
    },


    download() {
      let _this = this

      _this.maxHeight = _this.$listenHeight.getBodyHeight()

      _this.$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                let data={
                  agentName:_this.input_agent
                }
                _this.agentJs.importAgent(data)
                        .then(res => {
                          if(res.data.code==='0'){
                            _this.$alert('已操作导出，请到任务管理下载查看！')
                          }

                        })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消！'
                })
              })
    }
  }
}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
    .el-table__body-wrapper {
      height: calc(100% - 48px) !important; // 表格高度减去表头的高度
      overflow-y: auto;
    }
  }

  ::v-deep .el-button--primary {
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }

/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: 700;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.disflex {
  display: flex;
  align-items: center;
}
.titleflex {
  width: 35%;
}

</style>

